import { UrlBuilderService } from '@common/services/url-builder.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VatRate } from '@feature/invoice-upload/models/vat-rate';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VatRateService {

  constructor(
    private readonly urlProvider: UrlBuilderService,
    private readonly http: HttpClient
  ) { }

  getVatRates(): Observable<VatRate[]> {
    const url = this.urlProvider.getUrl('vatrates');
    return this.http.get<VatRate[]>(url);
  }

}

